import React, { Component } from 'react'
import './styles.css'
import Modal from '../modal'
import Util from '../../classes/util'


const estadoInicial = {
    produtosEscolhidos: [],
    valorTotal: 0
}

class ModalProdutos extends Component {

    state = {
        ...estadoInicial,
    }

    componentDidMount = async () => {
    }

    componentDidUpdate = async (prevProps) => {
        if (prevProps.open != this.props.open && this.props.open) {
            this.setState({ produtosEscolhidos: this.props.produtosEscolhidos });
            this.calculateTotalValue(this.props.produtosEscolhidos)
        }
    }

    calculateTotalValue = (produtos) => {
        let valor = 0;

        produtos.forEach((produto) => {
            valor += (produto.preco * produto.quantidade);
        });

        this.setState({ valorTotal: valor });
    }

    addProduct = (produto) => {
        const escolhidos = this.state.produtosEscolhidos;
        let {produtosEscolhidos} = this.state;

        if (escolhidos.find((p) => p.chave == produto.chave)) {
            produtosEscolhidos = escolhidos.map((p) => p.chave == produto.chave ? ({ ...p, quantidade: p.quantidade + 1 }) : ({ ...p }));
        } else {
            produtosEscolhidos = [...produtosEscolhidos, { ...produto, quantidade: 1 }];
        }

        this.setState({ produtosEscolhidos });
        this.calculateTotalValue(produtosEscolhidos);
    }

    removeProduct = (produto) => {
        let { produtosEscolhidos } = this.state;
        const escolhido = this.state.produtosEscolhidos.find((p) => p.chave == produto.chave);
        if (!escolhido) {
            return;
        }

        if (escolhido?.quantidade > 1) {
            produtosEscolhidos = produtosEscolhidos.map((p) => p.chave == produto.chave ? ({ ...p, quantidade: p.quantidade - 1 }) : ({ ...p }));
        } else {
            produtosEscolhidos.splice(produtosEscolhidos.findIndex((p) => p.chave == produto.chave), 1);

        }
        this.setState({ produtosEscolhidos });
        this.calculateTotalValue(produtosEscolhidos);
    }

    setQuantity = (produto, quantidade) => {
        const produtoEscolhido = this.state.produtosEscolhidos.find((p) => p.chave === produto.chave);
        let { produtosEscolhidos } = this.state;

        if (produtoEscolhido && quantidade > 0) {
            produtosEscolhidos = this.state.produtosEscolhidos.map((p) => p.chave === produto.chave ? ({ ...p, quantidade }) : ({ ...p }));
        } else if (produtoEscolhido && quantidade <= 0) {
            produtosEscolhidos = this.state.produtosEscolhidos.filter((p) => p.chave !== produto.chave);
        } else if (quantidade > 0) {
            produtosEscolhidos = [...this.state.produtosEscolhidos, { ...produto, quantidade }];
        }

        this.setState({ produtosEscolhidos });
        this.calculateTotalValue(produtosEscolhidos);
    }

    render() {
        return (
            <Modal open={this.props.open} onClose={() => this.props.onClose()} className={this.props.className ? this.props.className : null} styles={this.props.styles ? this.props.styles : null}>
                <div className='modal_produtos'>
                    <div className='modal_produtos_close'>
                        <div className='modal_close_icon' onClick={() => this.props.onClose()}>X</div>
                    </div>
                    <div className='modal_produtos_titulo'>
                        <span>{this.props.titulo}</span>
                    </div>
                    <hr style={{ width: "80%", marginLeft: "10%" }} />
                    <div className='modal_produtos_lista'>
                        {this.props.produtos.map((p) => (
                            <div key={p.chave} className={`produtos_lista_item ${this.state.produtosEscolhidos.find((prod) => prod.chave == p.chave) ? "produtos_lista_item_selected" : ""}`}>
                                <div className='produtos_lista_fim_linha'>R$ {Util.formatarDinheiro(p.preco)} - {p.Descricao}</div>
                                <div className='produtos_lista_fim_linha'>
                                    <div className='produtos_lista_buttons'>
                                        <button className='produtos_lista_add' onClick={() => this.addProduct(p)}>+</button>
                                        <input type="number" className='produtos_lista_quantidade' value={this.state.produtosEscolhidos.find((prod) => prod.chave == p.chave) ? `${this.state.produtosEscolhidos.find((prod) => prod.chave == p.chave)?.quantidade}` : 0} onChange={(e) => this.setQuantity(p, e.currentTarget.value)} onClick={(e) => e.target.select()} />
                                        <button className={`produtos_lista_minus ${this.state.produtosEscolhidos.find((prod) => prod.chave == p.chave) ? "" : "lista_button_disabled"}`} onClick={() => this.removeProduct(p)}>-</button>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                    <hr style={{ width: "80%", marginLeft: "10%" }} />
                    <div className='modal_produtos_lista_item bold'>
                        <div>Total</div>
                        <div>R$ {Util.formatarDinheiro(this.state.valorTotal)}</div>
                    </div>
                    <div className='modal_produtos_footer'>
                        <button className='modal_produtos_finalizar' onClick={() => this.props.onSubmit(this.state.produtosEscolhidos)}>
                            Finalizar
                        </button>
                    </div>
                </div>
            </Modal>
        )
    }
}

export default (ModalProdutos)